import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useRef, useState } from "react";
import api from "../../actprep-ui/utils/api";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { actSubjects } from "../../actprep-ui/constants/program";
import { capitalize } from "../../actprep-ui/utils/formatting";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";

export default function CategoryInfoForm({ category, onCreate, onEdit }) {
  const initialCategory = useRef(category);
  const [isChanged, setIsChanged] = useState(false);
  const isCreateMode = !category?.uuid;

  const getCategoryField = (category, field) => {
    if (category[field] == undefined || category[field] == null) {
      return "";
    }
    return category[field] || "";
  };

  const getCategoryFormData = (category = {}) => {
    const defaultFields = {
      name: "",
      subject: "",
      group: "",
    };

    return {
      ...defaultFields,
      ...Object.fromEntries(
        Object.keys(category).map((field) => [
          field,
          getCategoryField(category, field),
        ])
      ),
    };
  };

  const [formData, setFormData] = useState(getCategoryFormData(category));

  const handleFormChange = (field) => (event) => {
    if (!isChanged) {
      setIsChanged(true);
    }
    let value = event.target.value;

    if (field === "category") {
      value = { name: event.target.value };
    }

    setFormData((formData) => ({
      ...formData,
      [field]: value,
    }));
  };

  const handleReset = () => {
    setFormData(getCategoryFormData(initialCategory.current));
    setIsChanged(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isCreateMode) {
      const response = await api.post(apiUrls.admin.categories(), formData);
      showSuccessSnackbar("Lesson created successfully!");
      onCreate(response.data.data);
    } else {
      const response = await api.put(
        apiUrls.admin.categories(category.uuid),
        formData
      );
      showSuccessSnackbar("Lesson updated successfully!");
      onEdit(response.data.data);
    }
  };

  return (
    <Box component={"form"} onSubmit={handleSubmit}>
      <Grid container spacing={3} sx={{ width: "100%" }}>
        <Grid size={12}>
          <Typography variant="overline" fontWeight={"bold"}>
            Category Info
          </Typography>
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            value={formData.name}
            onChange={handleFormChange("name")}
            label="Name"
            variant="standard"
            type="text"
          />
        </Grid>
        <Grid size={12}>
          <FormControl fullWidth variant="standard">
            <InputLabel>Subject</InputLabel>
            <Select
              value={formData.subject}
              onChange={handleFormChange("subject")}
              label="Subject"
            >
              {actSubjects.map((subject) => (
                <MenuItem key={subject} value={subject}>
                  {capitalize(subject)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={12}>
          <TextField
            fullWidth
            value={formData.group}
            onChange={handleFormChange("group")}
            label="Group"
            variant="standard"
            type="text"
          />
        </Grid>
        <Grid size={12}>
          <ButtonGroup fullWidth disabled={!isChanged}>
            <Button disabled={isCreateMode} onClick={handleReset}>
              Reset
            </Button>
            <Button type="submit">{isCreateMode ? "Create" : "Save"}</Button>
          </ButtonGroup>
        </Grid>
      </Grid>
    </Box>
  );
}
